document.addEventListener('DOMContentLoaded', function() {
  var gtmScript = document.createElement('script');
  gtmScript.async = true;
  gtmScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-0B46JPEXPB';
  
  var gaScript = document.createElement('script');
  gaScript.async = true;
  gaScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-0B46JPEXPB');
  `;

  document.head.appendChild(gtmScript);
  document.head.appendChild(gaScript);

  // Tracking script

  const ctaButtons = document.querySelectorAll(".cta-button");

  ctaButtons.forEach(button => {
    button.addEventListener("click", function(){
      const ctaName = button.dataset.ctaName;
      const pagePath = location.pathname; // to know which landing page
      gtag('event', 'landing_cta_click', {
        'cta_name': ctaName,
        'landing_page': pagePath
      });
    });
  });

  const addToCartButtons = document.querySelectorAll("#subscription_quick_add_list .quick-add-to-cart-button");

  addToCartButtons.forEach(button => {
    button.addEventListener("click", function(){
      const productName = button.dataset.productName;
      const pagePath = location.pathname; // to differentiate which landing page
      gtag('event', 'quick_add_to_cart', {
        'product_name': productName,
        'landing_page': pagePath
      });
    });
  });
});